(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('olea-footer-localization')) {
  class OleaFooterLocalization extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const signal = this.events.signal;
      const initialize = () => {
        if (!this.isConnected) return;
        const form = this.querySelector('form');
        if (!form || typeof form.requestSubmit !== 'function') return;
        const apply = this.querySelector('.footer-localization__apply');
        if (apply) apply.hidden = true;
        this.addEventListener('change', event => {
          if (!(event.target instanceof HTMLSelectElement) || !form.contains(event.target)) return;
          form.requestSubmit();
        }, { signal });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true, signal });
      else initialize();
    }
    disconnectedCallback() { this.events?.abort(); }
  }
  customElements.define('olea-footer-localization', OleaFooterLocalization);
}

  } catch(e) { console.error(e); }
})();
})();
